import screens from "../screens";

const routes = {
  group: screens.Group,
  loading: screens.Loading,
  login: screens.Login,
  start: screens.Main,
  stats: screens.Stats,
  survey: screens.Question,
  submit: screens.Submit,
  session: screens.Session,
  result: screens.Result,
  thankyou: screens.ThankYou,
};

export default routes;
